import { Herb } from '../models/herb.model'; // Diese Zeile bleibt für deinen TypeScript-Kontext relevant

// src/app/data/herbs.ts
export const HERBS: Herb[] = [
  {
    id: 'basilikum',
    name: 'Basilikum',
    latinName: 'Ocimum basilicum',
    shortDescription: 'Aromatisches Kraut für mediterrane Küche und Tees',
    description: "Basilikum ist ein aromatisches Küchenkraut mit intensivem Duft. Es ist ein wesentlicher Bestandteil der mediterranen Küche.",
    imageUrl: 'images/6808d68539c869342fd01581.webp',
    colorHex: "#4CAF50",
    benefits: ['Reich an Antioxidantien', 'Unterstützt die Verdauung', 'Beruhigend'],
    uses: ['Pesto', 'Tomatengerichte', 'Salate', 'Tee'],
    cultivation: "Benötigt viel Sonnenlicht und warme Temperaturen. Wächst gut in Töpfen auf Balkonen und Fensterbänken.",
    properties: [
      "Reich an Vitamin K und Mangan",
      "Entzündungshemmende und antibakterielle Eigenschaften"
    ],
    harvestMonths: [6, 7, 8, 9],
    peakMonths: [7, 8],
    sowingIndoorsMonths: [3, 4, 5],
    sowingOutdoorsMonths: [5, 6],
    plantingOutMonths: [5, 6],
    cultivationNotes: "Lichtkeimer, Samen nur andrücken. Benötigt Wärme zum Keimen (>15°C). Auspflanzen/Direktsaat erst nach den Eisheiligen (Mitte Mai)."
  },
  {
    id: 'petersilie',
    name: 'Petersilie',
    latinName: 'Petroselinum crispum',
    shortDescription: 'Vielseitiges Kraut mit hohem Vitamin-C-Gehalt',
    description: "Petersilie ist ein vielseitiges Küchenkraut mit frischem Geschmack und hohem Nährwert.",
    imageUrl: 'images/67f6d09aadcdd9e67465577d.webp',
    colorHex: "#7CB342",
    benefits: ['Reich an Vitamin C', 'Entgiftend', 'Entzündungshemmend'],
    uses: ['Suppen', 'Saucen', 'Garnitur', 'Salate'],
    cultivation: "Wächst gut in halbschattigen Bereichen und benötigt regelmäßige Bewässerung. Kann im Garten oder in Töpfen angebaut werden.",
    properties: [
      "Extrem reich an Vitamin K und C",
      "Entgiftende Eigenschaften und erfrischt den Atem"
    ],
    harvestMonths: [3, 4, 5, 6, 7, 8, 9, 10, 11],
    peakMonths: [5, 6, 7, 8, 9],
    sowingIndoorsMonths: [2, 3, 4],
    sowingOutdoorsMonths: [3, 4, 5, 6, 7, 8],
    plantingOutMonths: [4, 5],
    cultivationNotes: "Dunkelkeimer, Samen leicht mit Erde bedecken. Keimung kann dauern (bis zu 4 Wochen). Relativ kältetolerant."
  },
  {
    id: 'rosmarin',
    name: 'Rosmarin',
    latinName: 'Rosmarinus officinalis',
    shortDescription: 'Aromatisches Nadelkraut mit holzigem Aroma',
    description: "Rosmarin ist ein aromatisches, immergrünes Kraut mit nadelartigen Blättern und holzigen Stielen.",
    imageUrl: 'images/67f96d92514731aa661921b1.webp',
    colorHex: "#33691E",
    benefits: ['Unterstützt das Gedächtnis', 'Antibakteriell', 'Fördert die Durchblutung'],
    uses: ['Bratkartoffeln', 'Fleischgerichte', 'Brot', 'Öle'],
    cultivation: "Bevorzugt sonnige, trockene Standorte und kalkarmen Boden. Ist in milden Klimazonen winterhart.",
    properties: [
      "Ätherische Öle fördern die Durchblutung",
      "Verbessert die Gedächtnisleistung"
    ],
    harvestMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    peakMonths: [5, 6, 7, 8],
    sowingIndoorsMonths: [2, 3, 4],
    plantingOutMonths: [5],
    cultivationNotes: "Vermehrung durch Stecklinge oft einfacher und schneller als Aussaat. Benötigt gut durchlässigen Boden. Auspflanzen erst nach den Eisheiligen (Mitte Mai)."
  },
  {
    id: 'thymian',
    name: 'Thymian',
    latinName: 'Thymus vulgaris',
    shortDescription: 'Robustes Kraut mit intensivem Aroma',
    description: "Thymian ist ein robustes, mehrjähriges Kraut mit kleinen, aromatischen Blättern und einem holzigen Stiel.",
    imageUrl: 'images/68062afad18d183a01f3f24c.webp',
    colorHex: "#8BC34A",
    benefits: ['Antimikrobiell', 'Hustenlindernd', 'Verdauungsfördernd'],
    uses: ['Fleischgerichte', 'Eintöpfe', 'Tee', 'Husten-Sirup'],
    cultivation: "Bevorzugt sonnige Standorte und gut durchlässigen Boden. Ist sehr trockenheitstolerant und winterhart.",
    properties: [
      "Reich an Thymol mit antibakterieller Wirkung",
      "Wirksam bei Erkältungen und Husten"
    ],
    harvestMonths: [4, 5, 6, 7, 8, 9, 10],
    peakMonths: [6, 7],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [4, 5],
    plantingOutMonths: [5],
    cultivationNotes: "Lichtkeimer, Samen nur andrücken. Braucht viel Sonne für volles Aroma. Auspflanzen nach den Eisheiligen."
  },
  {
    id: 'oregano',
    name: 'Oregano',
    latinName: 'Origanum vulgare',
    shortDescription: 'Würziges Heilkraut mit samtigen Blättern',
    description: "Oregano ist ein aromatisches, mehrjähriges Kraut mit kleinen Blättern und einem intensiven Geschmack.",
    imageUrl: 'images/6801273a0f5d5c2f6c01ae53.webp',
    colorHex: "#8D6E63",
    benefits: ['Antimikrobiell', 'Schweißhemmend', 'Entzündungshemmend'],
    uses: ['Pizza', 'Pastagerichte', 'Fleisch', 'Tee'],
    cultivation: "Bevorzugt sonnige Standorte und gut durchlässigen Boden. Ist sehr pflegeleicht und winterhart.",
    properties: [
      "Starke antioxidative und antibakterielle Eigenschaften",
      "Hilfreich bei Erkältungen und Verdauungsproblemen"
    ],
    harvestMonths: [5, 6, 7, 8, 9],
    peakMonths: [7, 8],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [4, 5],
    plantingOutMonths: [5],
    cultivationNotes: "Lichtkeimer, Samen nur andrücken. Rückschnitt nach der Blüte fördert Wachstum. Auspflanzen nach den Eisheiligen."
  },
  {
    id: 'majoran',
    name: 'Majoran',
    latinName: 'Origanum majorana',
    shortDescription: 'Erfrischendes Kraut mit kühlender Wirkung',
    description: "Majoran ist ein zarteres Verwandtes des Oregano mit einem süßeren, milderen Geschmack.",
    imageUrl: 'images/67f6ce2755bad497c76bfaa3.webp',
    colorHex: "#A5D6A7",
    benefits: ['Verdauungsfördernd', 'Erfrischend', 'Lindernd bei Kopfschmerzen'],
    uses: ['Wurst', 'Kartoffelgerichte', 'Eintöpfe', 'Tee'],
    cultivation: "Bevorzugt sonnige Standorte und lockeren, gut durchlässigen Boden. Ist weniger winterhart als Oregano, oft einjährig kultiviert.",
    properties: [
      "Enthält ätherische Öle",
      "Hilft bei Kopfschmerzen und Verdauungsproblemen"
    ],
    harvestMonths: [6, 7, 8, 9],
    peakMonths: [7, 8],
    sowingIndoorsMonths: [3, 4],
    plantingOutMonths: [5],
    cultivationNotes: "Wärmeliebend. Auspflanzen erst nach den Eisheiligen, da frostempfindlich. Nicht winterhart in kälteren Regionen."
  },
  {
    id: 'estragon',
    name: 'Estragon',
    latinName: 'Artemisia dracunculus',
    shortDescription: 'Mildes Zwiebelkraut mit feinem Aroma',
    description: "Estragon ist ein aromatisches Kraut mit schmalen Blättern und einem anisartigen Geschmack. Man unterscheidet französischen (intensiver, steril) und russischen (robuster, sät sich aus).",
    imageUrl: 'images/67f96c28514731aa661921a9.webp',
    colorHex: "#AFB42B",
    benefits: ['Reich an Eisen', 'Antibakteriell', 'Verdauungsfördernd'],
    uses: ['Sauce Béarnaise', 'Geflügel', 'Fisch', 'Essig'],
    cultivation: "Bevorzugt sonnige Standorte und sandigen, gut durchlässigen Boden. Französischer Estragon wird vegetativ vermehrt (Stecklinge, Teilung).",
    properties: [
      "Fördert Appetit und Verdauung",
      "Enthält Antioxidantien und entzündungshemmende Verbindungen"
    ],
    harvestMonths: [5, 6, 7, 8, 9],
    peakMonths: [7, 8],
    sowingIndoorsMonths: [3, 4],
    plantingOutMonths: [5],
    cultivationNotes: "Französischer Estragon hat das bessere Aroma, ist aber nicht samenfest (vegetative Vermehrung). Russischer kann gesät werden. Auspflanzen nach den Eisheiligen."
  },
  {
    id: 'schnittlauch',
    name: 'Schnittlauch',
    latinName: 'Allium schoenoprasum',
    shortDescription: 'Feines Zwiebelkraut mit mildem Geschmack',
    description: "Schnittlauch ist ein mehrjähriges Kraut mit röhrenförmigen Blättern und mildem Zwiebelgeschmack.",
    imageUrl: 'images/6808d85b39c869342fd015a2.webp',
    colorHex: "#689F38",
    benefits: ['Reich an Vitamin K', 'Unterstützt das Herz-Kreislauf-System', 'Antibakteriell'],
    uses: ['Quark', 'Salate', 'Eierspeisen', 'Garnitur'],
    cultivation: "Pflegeleicht und winterhart. Bevorzugt sonnige bis halbschattige Standorte und feuchten Boden.",
    properties: [
      "Enthält schwefelhaltige Verbindungen, gut für das Herz-Kreislauf-System",
      "Reich an Vitamin C und K"
    ],
    harvestMonths: [3, 4, 5, 6, 7, 8, 9, 10],
    peakMonths: [4, 5, 6, 7],
    sowingIndoorsMonths: [2, 3, 4],
    sowingOutdoorsMonths: [3, 4, 5, 6, 7],
    plantingOutMonths: [4, 5],
    cultivationNotes: "Regelmäßiger Schnitt fördert das Wachstum. Blüten sind essbar. Winterhart, kann früh ins Freie."
  },
  {
    id: 'salbei',
    name: 'Salbei',
    latinName: 'Salvia officinalis',
    shortDescription: 'Aromatisches Heilkraut mit samtig-grauen Blättern',
    description: "Salbei ist ein aromatisches Kraut mit grau-grünen, samtigen Blättern und einem würzigen Duft.",
    imageUrl: 'images/6810fa54232c0af5cf0ae7ec.webp',
    colorHex: "#558B2F",
    benefits: ['Entzündungshemmend', 'Hilft bei Halsschmerzen', 'Antibakteriell'],
    uses: ['Saltimbocca', 'Pasta', 'Heilmittel für Hals', 'Butter- oder Ölsaucen'],
    cultivation: "Bevorzugt sonnige Standorte und gut durchlässigen Boden. Ist trockenheitstolerant und mehrjährig.",
    properties: [
      "Entzündungshemmend",
      "Hilfreich bei Hals- und Verdauungsproblemen"
    ],
    harvestMonths: [5, 6, 7, 8, 9, 10],
    peakMonths: [6, 7, 8],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [5],
    plantingOutMonths: [5],
    cultivationNotes: "Rückschnitt im Frühjahr fördert buschigen Wuchs. Auspflanzen/Direktsaat nach den Eisheiligen. Keimung kann langsam sein."
  },
  {
    id: 'minze',
    name: 'Minze',
    latinName: 'Mentha spp.',
    shortDescription: 'Erfrischendes Kraut mit kühlendem Aroma',
    description: "Minze ist ein aromatisches Kraut mit charakteristischem Geruch und Geschmack, das in vielen Varianten vorkommt (Pfefferminze, Grüne Minze etc.).",
    imageUrl: 'images/6808dab339c869342fd015ad.webp',
    colorHex: "#66BB6A",
    benefits: ['Beruhigt den Magen', 'Erfrischend', 'Lindernd bei Erkältungen'],
    uses: ['Tees', 'Cocktails (Mojito)', 'Desserts', 'Orientalische Gerichte'],
    cultivation: "Wächst sehr schnell und kann invasiv werden (Wurzelsperre!). Am besten in Behältern anbauen. Mag feuchte Böden und Halbschatten.",
    properties: [
      "Beruhigt den Magen, hilft bei Verdauungsbeschwerden",
      "Erfrischend und kühlend"
    ],
    harvestMonths: [4, 5, 6, 7, 8, 9, 10],
    peakMonths: [6, 7, 8],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [4, 5, 6],
    plantingOutMonths: [5],
    cultivationNotes: "Stark wuchernd durch Ausläufer, Wurzelsperre empfohlen oder Topfkultur. Auspflanzen nach den Eisheiligen. Vermehrung durch Teilung/Ausläufer sehr einfach."
  },
  {
    id: 'dill',
    name: 'Dill',
    latinName: 'Anethum graveolens',
    shortDescription: 'Feines Kraut mit charakteristischem Aroma',
    description: "Dill ist ein einjähriges Kraut mit feinen, fadenförmigen Blättern und einem charakteristischen Aroma.",
    imageUrl: 'images/6808daed39c869342fd015b1.webp',
    colorHex: "#9CCC65",
    benefits: ['Reich an Calcium', 'Hilft bei Verdauungsbeschwerden', 'Beruhigt den Magen'],
    uses: ['Fischgerichte', 'Gurkensalat', 'Dips', 'Einlegen'],
    cultivation: "Bevorzugt sonnige bis halbschattige Standorte und feuchten, gut durchlässigen Boden. Sät sich oft selbst aus. Mag keine Umpflanzung.",
    properties: [
      "Hilft bei Verdauungsbeschwerden und Blähungen",
      "Reich an Calcium und anderen Mineralien"
    ],
    harvestMonths: [6, 7, 8, 9],
    peakMonths: [7, 8],
    sowingOutdoorsMonths: [4, 5, 6, 7],
    cultivationNotes: "Direktsaat empfohlen (April-Juli), da empfindlich beim Umpflanzen. Blüht schnell bei Hitze (Schossen), für Blatternte satzweise säen."
  },
  {
    id: 'koriander',
    name: 'Koriander',
    latinName: 'Coriandrum sativum',
    shortDescription: 'Vielseitiges Kraut mit zitrusartigem Aroma',
    description: "Koriander ist ein vielseitiges Kraut, dessen Blätter (frisch, zitrusartig) und Samen (würzig, gemahlen) verwendet werden. Der Geschmack der Blätter polarisiert.",
    imageUrl: 'images/6810f549232c0af5cf0ae7db.webp',
    colorHex: "#AED581",
    benefits: ['Reich an Antioxidantien', 'Fördert die Verdauung', 'Entgiftend'],
    uses: ['Asiatische Küche', 'Mexikanische Gerichte (Salsa)', 'Indische Gerichte', 'Gewürz (Samen)'],
    cultivation: "Bevorzugt kühle Temperaturen und direkte Aussaat. Geht schnell in Blüte (schosst), daher regelmäßig neu aussäen für Blattkoriander.",
    properties: [
      "Reich an Antioxidantien",
      "Fördert die Verdauung und hilft bei der Entgiftung von Schwermetallen"
    ],
    harvestMonths: [5, 6, 7, 8, 9],
    peakMonths: [6, 7],
    sowingOutdoorsMonths: [4, 5, 6, 7, 8],
    cultivationNotes: "Direktsaat empfohlen (April-Aug). Schosst schnell bei Wärme, daher satzweise säen für kontinuierliche Blatternte. Für Samen später säen oder schossen lassen."
  },
  {
    id: 'zitronenmelisse',
    name: 'Zitronenmelisse',
    latinName: 'Melissa officinalis',
    shortDescription: 'Beruhigendes Kraut mit zitronigem Duft',
    description: "Zitronenmelisse ist ein mehrjähriges Kraut mit zitronigem Duft und herzförmigen Blättern.",
    imageUrl: 'images/6808e5c339c869342fd015bb.webp',
    colorHex: "#C5E1A5",
    benefits: ['Beruhigend', 'Hilft bei Schlafproblemen', 'Lindert Angstzustände'],
    uses: ['Tees', 'Desserts', 'Salate', 'Sirup', 'Aromatherapie'],
    cultivation: "Wächst gut in sonnigen bis halbschattigen Lagen. Kann sich stark ausbreiten, daher in Behältern anbauen oder regelmäßig zurückschneiden.",
    properties: [
      "Beruhigend und entspannend",
      "Hilft bei Schlafproblemen, Angstzuständen und Verdauungsbeschwerden"
    ],
    harvestMonths: [5, 6, 7, 8, 9],
    peakMonths: [6, 7, 8],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [4, 5],
    plantingOutMonths: [5],
    cultivationNotes: "Sehr wüchsig, kann sich stark ausbreiten (Ausläufer). Regelmäßiger Schnitt fördert frische Blätter. Auspflanzen nach den Eisheiligen."
  },
  {
    id: 'baerlauch',
    name: 'Bärlauch',
    latinName: 'Allium ursinum',
    shortDescription: 'Wildwachsendes Knoblauchkraut mit intensivem Aroma',
    description: "Bärlauch ist ein wildwachsendes Kraut mit breiten Blättern und intensivem Knoblauchgeruch. Wächst im Frühling in Laubwäldern.",
    imageUrl: 'images/6808d65a39c869342fd0157d.webp',
    colorHex: "#DCE775",
    benefits: ['Reich an Vitamin C', 'Antibakteriell', 'Senkt den Blutdruck'],
    uses: ['Pesto', 'Suppen', 'Salate', 'Kräuterbutter', 'Aufstriche'],
    cultivation: "Wächst natürlich in schattigen, feuchten Wäldern. Kann im Garten an schattigen, feuchten Stellen kultiviert werden (Aussaat im Herbst oder Frühjahr).",
    properties: [
      "Reich an Vitamin C und schwefelhaltigen Verbindungen",
      "Antibakterielle Wirkung und kann den Blutdruck senken"
    ],
    harvestMonths: [3, 4, 5],
    peakMonths: [4],
    sowingOutdoorsMonths: [9, 10, 2, 3],
    cultivationNotes: "Kaltkeimer, Aussaat im Herbst oder sehr zeitigem Frühjahr. Sammelt nur, was sicher erkannt wird (Verwechslungsgefahr mit giftigen Maiglöckchen/Herbstzeitlose!). Bevorzugt schattige, feuchte Standorte."
  },
  {
    id: 'liebstoeckel',
    name: 'Liebstöckel',
    latinName: 'Levisticum officinale',
    shortDescription: 'Intensives Suppengewürz mit kräftigem Aroma ("Maggikraut")',
    description: "Liebstöckel ist ein großes, mehrjähriges Kraut mit einem intensiven, sellerieartigen Aroma, das an Maggi-Würze erinnert.",
    imageUrl: 'images/680fc68db9f6ae04f8a202bb.webp',
    colorHex: "#827717",
    benefits: ['Fördert die Verdauung', 'Harntreibend', 'Hilft bei Wassereinlagerungen'],
    uses: ['Suppen', 'Eintöpfe', 'Kartoffelgerichte', 'Salate (sparsam)'],
    cultivation: "Wird bis zu 2 Meter hoch und bevorzugt tiefgründigen, nährstoffreichen, feuchten Boden. Braucht Platz im Garten.",
    properties: [
      "Fördert die Verdauung und wirkt harntreibend",
      "Hilft bei Wassereinlagerungen"
    ],
    harvestMonths: [4, 5, 6, 7, 8, 9, 10],
    peakMonths: [6, 7, 8],
    sowingIndoorsMonths: [3, 4],
    sowingOutdoorsMonths: [4, 5],
    plantingOutMonths: [5],
    cultivationNotes: "Sehr wüchsig und ausdauernd. Benötigt viel Platz (bis 2m hoch). Auspflanzen nach den Eisheiligen."
  },
  {
    id: 'kuemmel',
    name: 'Kümmel',
    latinName: 'Carum carvi',
    shortDescription: 'Traditionelles Gewürz für Brot und deftige Gerichte',
    description: "Kümmel ist eine zweijährige Pflanze, deren Samen als Gewürz verwendet werden. Hat ein warmes, leicht bitteres Aroma.",
    imageUrl: 'images/6810f9ff232c0af5cf0ae7e1.webp',
    colorHex: "#795548",
    benefits: ['Verdauungsfördernd', 'Hilft bei Blähungen', 'Gut bei Koliken'],
    uses: ['Brot', 'Käse', 'Kohlgerichte', 'Verdauungsschnaps'],
    cultivation: "Wächst gut in sonnigen Lagen mit gut durchlässigem Boden. Im ersten Jahr bildet sich eine Rosette, im zweiten Jahr Blüte und Samen.",
    properties: [
      "Fördert die Verdauung und reduziert Blähungen",
      "Traditionell bei Koliken bei Säuglingen eingesetzt"
    ],
    harvestMonths: [7, 8],
    peakMonths: [8],
    sowingOutdoorsMonths: [4, 5, 6, 8, 9],
    cultivationNotes: "Zweijährig. Direktsaat im Frühjahr oder Spätsommer für Samenreife im nächsten Sommer. Blüht im zweiten Jahr."
  },
  {
    id: 'lorbeer',
    name: 'Lorbeer',
    latinName: 'Laurus nobilis',
    shortDescription: 'Aromatisches Blattgewürz für Suppen und Eintöpfe',
    description: "Lorbeer ist ein immergrüner Strauch oder kleiner Baum mit aromatischen, ledrigen Blättern.",
    imageUrl: 'images/6808e62839c869342fd015c1.webp',
    colorHex: "#33691E",
    benefits: ['Verdauungsfördernd', 'Entzündungshemmend', 'Schmerzlindernd'],
    uses: ['Suppen', 'Eintöpfe', 'Marinaden', 'Gewürzmischungen (Bouquet garni)'],
    cultivation: "In milden Klimazonen im Freien, sonst als Kübelpflanze (frostfrei überwintern). Langsam wachsend und langlebig.",
    properties: [
      "Enthält ätherische Öle",
      "Verdauungsfördernd und entzündungshemmend"
    ],
    harvestMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    peakMonths: [9, 10],
    cultivationNotes: "Langsam wachsend. Gut für Kübelkultur geeignet. Frostempfindlich, braucht Winterschutz oder frostfreie Überwinterung. Vermehrung meist über Stecklinge."
  }
];